/** Extent of the IEM national composite + HRRR tiles (lower 48), generously padded. Outside
 *  it the engine switches the map to RainViewer's global mosaic (no future frames). */
export function inLower48Radar(lat: number, lon: number): boolean {
  return lat >= 20 && lat <= 53 && lon >= -130 && lon <= -60
}
